<div 
  class="sidebar-container" 
  [ngClass]="{ 'collapsed': !isSidebarOpen, 'expanded': isSidebarOpen}">
  <ul>
    @for (item of modelUpper; track item; let i = $index) {
    @if (item.logo) {
    <li class="sidebar-title">
      @if (isSidebarOpen) {
        <img [src]="item.logo" alt="Logo completo" class="logo-complete">
      } @else {
        <img src="assets/layout/images/logo-simple.png" alt="Logo simple" class="logo-simple">
      }
    </li>
    } @else if (item.separator) {
    <li class="sidebar-separator"></li>
    } @else {
    <li class="item-sidebar">
      <app-item-menu [item]="item" [index]="i" [root]="true" [isSidebarOpen]="isSidebarOpen" (itemClick)="handleMenuItemClick($event)">
      </app-item-menu>
    </li>
    }
    }
  </ul>

  <!-- Model para poner los botones abajo -->
  <ul class="buttons-container-down">

    @for (item of modelLower; track item; let i = $index) {

    <!-- Botón de cerrar el sidebar -->
    @if (item.id === 'isSidebarOpen') {

    <app-item-menu class="item-content" [item]="item" [index]="i" [root]="true" [isSidebarOpen]="isSidebarOpen">
    </app-item-menu>

    }

    <!-- Contenedor para los botones de tema -->
    @if (item.id === 'lightMode') {
    <li class="theme-buttons-container">
      <div>
        @if(!(currentTheme === 'light' && !isSidebarOpen)){
        <button class="theme-button" (click)="switchTheme('light')" [disabled]="currentTheme === 'light'">
          <lucide-icon name="Sun" class="theme-button-icon"></lucide-icon>
          @if (isSidebarOpen) {
          <span class="button-label">Claro</span>
          }
        </button>
        }
        @if(!(currentTheme === 'dark' && !isSidebarOpen)){
        <button class="theme-button" (click)="switchTheme('dark')" [disabled]="currentTheme === 'dark'">
          <lucide-icon name="Moon" class="theme-button-icon"></lucide-icon>
          @if (isSidebarOpen) {
          <span class="button-label">Oscuro</span>
          }
        </button>
        }

      </div>
    </li>
    }
    }

    <div class="bottom-buttons-container">
      <!-- Logout Button -->
      <div class="logout-container">
        @for (item of modelResponsive; track item; let i = $index) {
          @if (item.id === 'logout') {
            <app-item-menu [item]="item" [index]="i" [root]="true"></app-item-menu>
          }
        }
      </div>
    
      <!-- Theme Button -->
      <div class="theme-buttons-responsive">
        <div>
          <button
           class="theme-button"
           (click)="switchTheme(isLightTheme() ? 'dark' : 'light')"
         >
           <lucide-icon 
             [name]="isLightTheme() ? 'Moon' : 'Sun'" 
             class="theme-button-icon">
           </lucide-icon>
         </button>
        </div>
      </div>
    </div>
    
  </ul>

</div>